import { render, staticRenderFns } from "./AppTree.vue?vue&type=template&id=3bbceb27&scoped=true&"
import script from "./AppTree.vue?vue&type=script&lang=js&"
export * from "./AppTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbceb27",
  null
  
)

export default component.exports